import { Box } from "@mui/material";

// Shared monospace pre-block for cost-formula explanations. Rendered
// inside the various "Cost Estimate" panels (SearchEnvCard, ResultsPanel,
// SearchEnvProvisionModal) so the math reveal looks identical across
// surfaces. The string contents are produced operator-side
// (search-env panels) or client-side (workflow-compute panel) — this
// component only owns presentation.
export function CostFormulaPre({ formulaLines }: { formulaLines: string[] }) {
  return (
    <Box
      component="pre"
      sx={{
        mt: 1.5,
        p: 1.5,
        borderRadius: 1,
        backgroundColor: "grey.50",
        border: "1px solid",
        borderColor: "divider",
        fontFamily: "monospace",
        fontSize: 12,
        lineHeight: 1.5,
        color: "text.primary",
        overflowX: "auto",
        margin: 0,
        whiteSpace: "pre",
      }}
    >
      {formulaLines.join("\n")}
    </Box>
  );
}
